import React, { useState } from 'react'
import './style.sass'
import PropTypes from 'prop-types'
import FieldWrapper from '../FieldWrapper'
import CopiedElement from '../../CopiedElement'
import { CopyToClipboard } from 'react-copy-to-clipboard'

const TextFieldWithCopy = ({ type = "text", displayName, placeholder, description, errorMessage, disabled, value, onChange }) => {
  // ===== Local State =====
  const [showCopied, setShowCopied] = useState(false)

  return (
    <FieldWrapper
      displayName={displayName}
      description={description}
      errorMessage={errorMessage}
      disabled={disabled}
    >
      <div className="text-field-with-copy-container">
        <input
          type={type}
          placeholder={placeholder || displayName}
          value={value ?? ""}
          onChange={onChange ? (e) => onChange(e.target.value) : () => { }}
          disabled={disabled}
        />
        <CopyToClipboard text={value} onCopy={() => setShowCopied(true)}>
          <button className='btn btn-no-fill'>
            <i className="fa fa-copy"></i>
          </button>
        </CopyToClipboard>
        {showCopied && <CopiedElement right={0} top={40} onTimout={() => setShowCopied(false)}/>}
      </div>
    </FieldWrapper>
  )
}

TextFieldWithCopy.propTypes = {
  type: PropTypes.oneOf(['text', 'email', 'number', 'password']),
  displayName: PropTypes.string,
  placeholder: PropTypes.string,
  description: PropTypes.string,
  errorMessage: PropTypes.string,
  disabled: PropTypes.bool,
  value: PropTypes.any,
  onChange: PropTypes.func,
}

export default TextFieldWithCopy
